<template>
  <div class="confirmorders">
    <h1 class="subheading grey--text">Orders awaiting confirmation</h1>
    <h2 class="subheading font-weight-thin grey--text">
      {{ getOrderCount() }} waiting
      <v-btn
        icon
        class="font-weight-thin grey--text"
        @click="getOrdersForConfirmation"
        ><v-icon>refresh</v-icon></v-btn
      >
    </h2>

    <v-container class="my-5">
      <v-expansion-panels>
        <v-expansion-panel
          v-for="order in ordersAwaitingConfirmation"
          :key="order.cartId"
        >

          <v-expansion-panel-header
            v-on:click="setCartId(order.cartId)"
            class="py-1"
          >
            <v-row class="py-0">
              <v-col cols="6"> {{ order.cartId }} </v-col>
              <v-col cols="6">
                <div v-if="order.email" class="font-weight-bold">
                  Email: {{ order.email }}
                  <span class="caption"
                    ><v-icon
                      size="15"
                      v-on:click.stop="copyEmailToClipboard(order.email)"
                      >content_copy</v-icon
                    ></span
                  >
                </div>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </v-expansion-panel-header>
          
          <v-expansion-panel-content>
            <v-card class="px-4 grey--text">
              <v-card-text class="packed">
                <v-row>
                  <v-col cols="6 packed">
                    <div>Payment method: {{ order.type }}</div>
                  </v-col>
                  <v-col cols="6 packed">
                    <div>Order Date: {{ order.orderDate }}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6 packed">
                    <div>Cart Net Value: {{ order.netCost.price }}</div>
                  </v-col>
                  <v-col cols="6 packed">
                    <div>Cart Total Value: {{ order.totalCost.price }}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6 packed">
                    <div v-if="order.notes" class="font-weight-bold">
                      Notes: {{ order.notes }}
                    </div>
                  </v-col>
                </v-row>
                <div
                  v-for="cartitem in cartContents.cart"
                  :key="cartitem.id"
                  class="px-6 my-3"
                >
                  <v-row>
                      {{ cartitem.item }} - {{ cartitem.description }} ({{
                        cartitem.price
                      }})
                  </v-row>
                </div>
                <v-row>
                  <ConfirmOrderDialog
                    v-bind:cartId="cartId"
                    @orderChanged="getOrdersForConfirmation"
                  />
                  <v-btn class="warning mx-1" @click="cancelOrderAndNotify"
                    ><v-icon>cancel_schedule_send</v-icon
                    ><span>Cancel Order (Notify)</span></v-btn
                  >
                  <v-btn class="error" @click="cancelOrderSilent"
                    ><v-icon>delete_forever</v-icon
                    ><span>Cancel Order (Silent)</span></v-btn
                  >
                  <v-btn
                    class="primary mx-1"
                    :loading="resending"
                    @click="resendOrderEmail"
                    ><v-icon>forward_to_inbox</v-icon
                    ><span>Resend Notification</span></v-btn
                  >

                  <v-btn
                    absolute
                    right
                    class="primary"
                    @click="copyCartIdToClipboard"
                  >
                    <v-icon>add_circle_outline</v-icon>
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";
import ConfirmOrderDialog from "../components/ConfirmOrderDialog";
import { store } from "../store.js";

export default {
  components: { ConfirmOrderDialog },
  data() {
    return {
      ordersAwaitingConfirmation: [],
      cartId: "",
      cartContents: [],
      resending: false,
    };
  },
  created() {
    this.getOrdersForConfirmation();
  },
  methods: {
    async getOrdersForConfirmation() {
      this.ordersAwaitingConfirmation = await cartApi.getOrdersConfirmation();
    },
    async setCartId(cartId) {
      this.cartId = cartId;
      this.cartContents = await cartApi.getCart(cartId);
    },
    getOrderCount() {
      return this.ordersAwaitingConfirmation.length;
    },
    async cancelOrderAndNotify() {
      await cartApi.cancelOrderAndNotify(this.cartId);
      this.getOrdersForConfirmation();
    },
    async cancelOrderSilent() {
      await cartApi.cancelOrderSilent(this.cartId);
      this.getOrdersForConfirmation();
    },
    async resendOrderEmail() {
      this.resending = true;
      try {
        await cartApi.resendSubmitOrder(this.cartId);
        this.$toast("Order confirmation email resent");
      } catch (e) {
        this.$toast("Error resending order email: " + e);
      }
      this.resending = false;
    },
    async copyCartIdToClipboard() {
      let copyRes = false;
      await navigator.clipboard.writeText(this.cartId).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied cartId " + this.cartId);
      store.storeCartId(this.cartId);
    },
    async copyEmailToClipboard(email) {
      let copyRes = false;
      await navigator.clipboard.writeText(email).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied email " + email);
    },
  },
};
</script>

<style>
.packed {
/*  color: red; */
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>